<template>
  <!--  批量修改分类操作-->
  <el-dialog :visible.sync="modal.classifyVisible"
             width="650px"
             center>
    <el-form :model="listQuery">
      <el-form-item label="请选择要修改的分类："
                    :label-width="formLabelWidth">
        <el-cascader v-model="productCategoryValue"
                     placeholder="请选择分类"
                     :props="optionProps"
                     @change="handleCategoryChange"></el-cascader>
      </el-form-item>
    </el-form>
    <div slot="footer"
         class="dialog-footer">
      <el-button @click="modal.classifyVisible = false">取 消</el-button>
      <el-button type="primary"
                 @click="handleConfirm">确 认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { shopClassifyList } from '@/api/shopClassify'
export default {
  name: "UpdateClassify",
  props: {
    modal: Object
  },
  data() {
    const that = this
    return {
      // 级联面板定制
      optionProps: {
        expandTrigger: 'hover',
        lazy: true,
        lazyLoad(row, resolve) {
          if (row.level == 0) {
            row.value = 0
          }
          shopClassifyList({
            parentId: row.value,
            mchtId: that.$store.getters.mchtId,
            status: 2
          }).then(res => {
            let list = res.data
            list.map(item => {
              item.value = item.productCategoryId
              item.label = item.productCategoryName
              item.leaf = item.level >= 3
            })
            resolve(list)
          })
        }
      },
      formLabelWidth: '160px',
      data: {
        classify: null,
        radio: null
      },
      productCategoryValue: [],
      listQuery: {
        categoryIdI: null,
        categoryIdIi: null,
        categoryIdIii: null
      }
    }
  },
  methods: {
    // 监听级联面板value
    handleCategoryChange() {
      this.listQuery.categoryIdI = this.productCategoryValue[0];
      this.listQuery.categoryIdIi = this.productCategoryValue[1];
      this.listQuery.categoryIdIii = this.productCategoryValue[2];
      // console.log('value', labels)
    },
    handleConfirm() {
      console.log('listQuery', this.listQuery)
      this.$emit('handleClassify', this.listQuery)
    }
  }
}
</script>

<style scoped>
.notice {
  margin: 0 0 0 172px;
  color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/views/pms/components/UpdateClassify.vue